'use client';
import React from 'react';
import { Globe } from 'lucide-react';

interface LanguageToggleProps {
  lang: 'en' | 'ar';
  onChange: (lang: 'en' | 'ar') => void;
  className?: string;
}

export default function LanguageToggle({ lang, onChange, className = '' }: LanguageToggleProps) {
  return (
    <div className={`flex items-center gap-1 p-1 rounded-lg bg-muted ${className}`}>
      <Globe size={14} className="text-muted-foreground mx-1" />
      <button
        onClick={() => onChange('ar')}
        className={`px-2.5 py-1 rounded text-xs font-medium transition-all ${
          lang === 'ar' ?'bg-primary text-primary-foreground' :'text-muted-foreground hover:text-foreground'
        }`}
      >
        العربية
      </button>
      <button
        onClick={() => onChange('en')}
        className={`px-2.5 py-1 rounded text-xs font-medium transition-all ${
          lang === 'en' ?'bg-primary text-primary-foreground' :'text-muted-foreground hover:text-foreground'
        }`}
      >
        English
      </button>
    </div>
  );
}